import React from "react"
import styled from "styled-components"

import { Box } from "components/box"
import { Paragraph } from "components/text"
import { Color } from "theme"

const IconContainer = styled(Box).attrs({
  px: 4,
  ml: 1
})`
  border-radius: 1.937rem;
  padding: 0.375rem 0.75rem;
`

const IconParagraph = styled(Paragraph)`
  font-size: 0.625rem;
  letter-spacing: 0.106rem;
`

type RoundTextIconProps = {
  bg: Color
}

const RoundTextIcon: React.FC<RoundTextIconProps> = ({ bg, children }) => (
  <IconContainer bg={bg}>
    <IconParagraph bold>{children}</IconParagraph>
  </IconContainer>
)

export default RoundTextIcon
